/**
 * 会社法人等番号の区切り文字（NFKC正規化後の半角ハイフン・空白）。
 * BE の共通ドメイン `domains/corporate_number` の normalize_corporate_digits が除去する `[-\s]` と同じ集合。
 * 全角ハイフン(U+FF0D)・全角空白(U+3000)はNFKCで半角に畳まれるため列挙不要
 */
const CORPORATE_NUMBER_SEPARATOR_PATTERN = /[-\s]/g;

/**
 * 法人番号・会社法人等番号を照合用に正規化する（NFKC正規化＋ハイフン・空白の除去）。
 * BEの normalize_corporate_number（NFKC → 共通ドメインの normalize_corporate_digits）と同じ仕様。
 * 区切り文字以外（長音符やダッシュ類を含む）は除去せず残し、形式チェックで弾く
 * @param value 入力された法人番号・会社法人等番号
 * @returns 正規化後の文字列
 */
export const normalizeCorporateNumber = (value: string): string =>
  value.normalize("NFKC").replace(CORPORATE_NUMBER_SEPARATOR_PATTERN, "");
